export const entryTypes = [
  'addressBook',
  'case',
  'campaign',
  'lead',
  'opportunity',
  'salesProcess',
  'team',
  'user',
  'secAccess',
] as const;

export type EntryType = (typeof entryTypes)[number];
